(function($) {
  "use strict";
  var setAttributes;
  setAttributes = function(el, attrs) {
    Array.prototype.slice.call(attrs).forEach(function(attr) {
      if (attr.name !== "data-bt-icon") {
        el.setAttribute(attr.name, attr.value);
      }
    });
  };
  Array.prototype.forEach.call(document.querySelectorAll("[data-bt-icon]"), function(element, index) {
    var svg, use;
    svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    setAttributes(svg, element.attributes);
    use = document.createElementNS('http://www.w3.org/2000/svg', 'use');
    use.setAttributeNS('http://www.w3.org/1999/xlink', 'xlink:href', svgSpritePath + '#' + element.getAttribute("data-bt-icon"));
    svg.appendChild(use);
    element.parentNode.replaceChild(svg, element);
  });


  //$('[placeholder]').placeholder();


$(window).load(function() {
  // TwentyTwenty
  $("#before-after").twentytwenty();
});


$(document).ready(function(){

  // Term icons 
  $(".icon-cat.bodenarbeiten").addClass("uk-icon-th-large");
  $(".icon-cat.farb-wandgestaltung").addClass("uk-icon-tint");
  $(".icon-cat.raumausstattung").addClass("uk-icon-adjust");
  $(".icon-cat.trockenbau-ausbau").addClass("uk-icon-home");


  // Projekte Lightbox
  $('a.iframe').colorbox({iframe:true, width:"100%", height:"100%", fixed:true });
  $('.group-projekte').colorbox({rel:'group-projekte'});

  //$('a.colorbox').colorbox({rel:'gal', width:"100%", height:"100%"});

/*

  $(".post-link").click(function(event){
    event.preventDefault();
    var target = $(event.currentTarget);  

      $.ajax({
        url : oe_globals.ajaxURL,
        type : 'post',
        data : {
          action : 'load_portfolio',
          content: {
            id : target.attr('data-id')
          }
        },
        error : function(request){
          alert("Error");
        },
        success: function( response ) {
          //alert( result );
    
          
          $("#single-post-container").hide().html(response.html).fadeIn(200, function(){

            $('html, body').stop().animate({
                'scrollTop': $("#single-post-container").offset().top-90
            }, 500, 'swing', function () {

            });

          });
          //$("#single-post-container").html(response.html);
          
    
          $('#close-container').click(function(){
            //console.log("clicked close");    
            
              $('html, body').stop().animate({
                  'scrollTop': $("#filter-projekte").offset().top-90
              }, 500, 'swing', function () {

                  window.location.hash = '';
                  $("#single-post-container").fadeOut(500, function() {
                    $("#single-post-container").empty();
                  });


              });              
            
          });
    
        }
      });    
  });
*/

}); // end document.ready

})(jQuery);